import { FC } from "react";
import FiltersBarContent, { FiltersBarContentProps } from "../components/FiltersBarContent";

const FiltersBarWeb: FC<FiltersBarContentProps> = (props) => {
  return (
    <div className="flex flex-col md:p-4 p-1 gap-3">
      <FiltersBarContent {...props} />
    </div>
  );
};

export default FiltersBarWeb;
